/*global serverPath*/
/*global location*/
(function() {
    'use strict';
    var path = '';
    var realtime;
    if (serverPath === 'production') {
        realtime = 'https://realtime.emarket.do';
        path = '//' + location.host;
    } else {
        path = serverPath + ':3000';
        realtime = serverPath + ':3001/realtime';
    }
    angular.module('emarket.commons').constant('PATH', {
        server: '//' + location.host,
        api: path + '/api',
        realtime: realtime
    });
}());
